import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { STATIC_CONFIG } from './core/config';

console.log(`Citizen Portal - ${STATIC_CONFIG.VERSION} - ${STATIC_CONFIG.ENV}`);

// Init styles
require('@/assets/styles.scss');

const app = createApp(App);

// Standard components - we register these globally for convenience / brevity 
import AppPageFrame from "./AppPageFrame.vue";
import LoadingPage from "@/components/LoadingPage.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ModalDialog from "@/components/ModalDialog.vue";

import DocumentUploadWidget from "@/components/DocumentUploadWidget.vue";
import FormCheckboxField from "@/components/FormCheckboxField.vue";
import FormCheckboxGroupField from "@/components/FormCheckboxGroupField.vue";
import FormDateField from "@/components/FormDateField.vue";
import FormNumberField from "@/components/FormNumberField.vue";
import FormRadioGroupField from "@/components/FormRadioGroupField.vue";
import FormSelectField from "@/components/FormSelectField.vue";
import FormStringListField from "@/components/FormStringListField.vue";
import FormTextField from "@/components/FormTextField.vue";

import SaveButton from "@/components/SaveButton.vue";

import Columns from "@/components/layout/Columns.vue";
import HalfColumn from "@/components/layout/HalfColumn.vue";

app.component('AppPageFrame', AppPageFrame);

app.component('LoadingPage', LoadingPage);
app.component('LoadingSpinner', LoadingSpinner);

app.component('ModalDialog', ModalDialog);

app.component('DocumentUploadWidget', DocumentUploadWidget);

app.component('FormCheckboxField', FormCheckboxField);
app.component('FormCheckboxGroupField', FormCheckboxGroupField);
app.component('FormDateField', FormDateField);
app.component('FormRadioGroupField', FormRadioGroupField);
app.component('FormSelectField', FormSelectField);
app.component('FormStringListField', FormStringListField);
app.component('FormTextField', FormTextField);
app.component('FormNumberField', FormNumberField);

app.component('SaveButton', SaveButton);

app.component('Columns', Columns);
app.component('HalfColumn', HalfColumn);

app.use(router);

app.mount('#app');
